import React from 'react';
import { createMuiTheme, makeStyles, MuiThemeProvider, Paper, Switch, TableCell, Tabs, Tab, Typography, withStyles } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import { Divider, TextField, Snackbar } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable from "mui-datatables";
import Loader from 'react-loader-spinner'
import { useLocation } from 'react-router-dom';
import MuiAlert from '@material-ui/lab/Alert';
import ic_error from '../../assets/ic_error.png';
import api from '../api'
import { useHistory } from 'react-router-dom';

const ct = require("../../library/CustomTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions()

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function AddSchedulePoli(props) {
    const location = useLocation();
    const namaPoli = location.state.namaPoli.toUpperCase()
    const idPoli = location.state.idPoli
    console.log(location);
    const history = useHistory()
    const [waktu, set_waktu] = React.useState(null)
    let effective_date;
    const [hari, setHari] = React.useState([])
    const [time_start, set_time_start] = React.useState(null)
    const [time_end, set_time_end] = React.useState(null)
    const [list_room, set_list_room] = React.useState([])
    const [data, set_data] = React.useState([])
    const [errorMessage, setErrorMessage] = React.useState(null)
    const [visibleError, setVisibleError] = React.useState(false);
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    // const [flagging, setFlagging] = React.useState(false)
    // const [selectedDate, setSelectedDate] = React.useState(new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1} ${new Date().getDate()} 00:00`));
    // const [selectedDateEnd, setSelectedDateEnd] = React.useState(new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1} ${new Date().getDate()} 00:00`));
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [selectedDateEnd, setSelectedDateEnd] = React.useState(null);

    const [errorJamMulai, setErrorJamMulai] = React.useState(false)
    const [errorJamSelesai, setErrorJamSelesai] = React.useState(false)
    const [errorHari, setErrorHari] = React.useState(false)
    const [errorTglBerlaku, setErrorTglBerlaku] = React.useState(false)
    const [textJamMulai, setTextJamMulai] = React.useState(false)
    const [textJamSelesai, setTextJamSelesai] = React.useState(false)
    const [textTglBerlaku, setTextTglBerlaku] = React.useState(false)
    const [textHari, setTextHari] = React.useState(false)

    const handleDateChange = (date) => {
        if (date && !isNaN(new Date(date).getTime())) {
            setErrorJamMulai(false)
            setTextJamMulai(null)
            let jam = date.getHours()
            let menit = date.getMinutes()
            setSelectedDate(date)
            if (jam < 10) {
                jam = `0${jam}`
            }
            console.log(jam, menit);
            if (menit < 10) {
                menit = `0${menit}`
            }
            if (menit === 0) {
                set_data({
                    ...data,
                    "time_start": `${jam}:${menit}0`
                });
                set_time_start(`${jam}:${menit}0`)
            } else {
                set_data({
                    ...data,
                    "time_start": `${jam}:${menit}`
                });
                set_time_start(`${jam}:${menit}`)
            }
        }
    };

    const handleDateEndChange = (date) => {
        if (date && !isNaN(new Date(date).getTime())) {
            setErrorJamSelesai(false)
            setTextJamSelesai(null)
            let jam = date.getHours()
            let menit = date.getMinutes()
            console.log(jam, menit);
            setSelectedDateEnd(date)
            if (menit === 0) {
                set_data({
                    ...data,
                    "time_end": `${jam}:${menit}0`
                });
                set_time_end(`${jam}:${menit}0`)
            } else {
                set_data({
                    ...data,
                    "time_end": `${jam}:${menit}`
                });
                set_time_end(`${jam}:${menit}`)
            }
        }
    };
    let schedule = []
    if (waktu) {
        let date = waktu.getDate()
        let month = waktu.getMonth() + 1
        let year = waktu.getFullYear()
        console.log(date, month, year);
        effective_date = `${year}-${month}-${date}`
    }
    console.log(hari)
    React.useEffect(() => {
        getRuangan()
    }, [])

    const getRuangan = () => {
        api.create().getRoom().then(response => {
            let listRoom = []
            response.data.data.map((el, idx) => {
                listRoom.push({
                    id: idx + 1,
                    name: `Gd. ${el.building_name}, Lantai.${el.floor}, Ruangan ${el.name}`
                })
            })
            set_list_room(listRoom)
        })
    }
    console.log(hari);

    const handleSubmit = () => {
        if (waktu === null) {
            setErrorTglBerlaku(true)
            setTextTglBerlaku("Tanggal Harus Diisi")
        } else if (time_start === null) {
            setErrorJamMulai(true)
            setTextJamMulai("Jam Mulai Harus Diisi")
        } else if (time_end === null) {
            setErrorJamSelesai(true)
            setTextJamSelesai("Jam Selesai Harus Diisi")
        } else {
            schedule = [
                {
                    "schedule_date": `${waktu.getFullYear()}-${waktu.getMonth() + 1 < 10 ? `0${waktu.getMonth() + 1}` : waktu.getMonth() + 1}-${waktu.getDate()}`,
                    "session": [
                        {
                            "time_start": time_start,
                            "time_end": time_end
                        }
                    ]
                }
            ]
            let payload = {
                "polyclinic_id": idPoli,
                "schedule": schedule
            }
            console.log(payload);
            api.create().createSessionPoli(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.message)
                        setStatusAlert("Succes")
                        setTimeout(() => {
                            history.goBack()
                        }, 1000)
                    } else {
                        setErrorMessage(response.data.data)
                        setVisibleError(true)
                    }
                }
            })
        }
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleBatal = () => {
        history.goBack()
    }

    return (
        <div>
            <div>
                <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity={statusAlert}>
                        {messageAlert}
                    </Alert>
                </Snackbar>
                <Typography style={{ paddingTop: 30, paddingLeft: 33, color: '#278863' }}>Poliklinik {namaPoli}</Typography>
                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, margin: 'auto', width: '80%' }}>
                    <div className="column-1" style={{ marginRight: 50 }}>
                        <div className="">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="tanggalBerlaku"
                                    required={true}
                                    label="Tanggal Berlaku"
                                    format="dd/MM/yyyy"
                                    minDate={new Date()}
                                    error={errorTglBerlaku}
                                    helperText={textTglBerlaku}
                                    value={waktu}
                                    onChange={(date) => {
                                        set_waktu(date)
                                        setErrorTglBerlaku(false)
                                        setTextTglBerlaku("")
                                        forceUpdate()
                                    }}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{ width: 400 }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        <div className="">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardTimePicker
                                    style={{ width: 400, marginTop: 38 }}
                                    margin="normal"
                                    id="jamMulai"
                                    required={true}
                                    clearLabel
                                    ampm={false}
                                    error={errorJamMulai}
                                    helperText={textJamMulai}
                                    label="Jam Mulai"
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change time',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    </div>
                    <div className="column-2">
                        <div className="">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardTimePicker
                                    margin="normal"
                                    style={{ marginTop: 15, width: 400 }}
                                    id="jamSelesai"
                                    clearLabel
                                    required={true}
                                    error={errorJamSelesai}
                                    ampm={false}
                                    helperText={textJamSelesai}
                                    label="Jam Selesai"
                                    value={selectedDateEnd}
                                    onChange={handleDateEndChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change time',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div onClick={() => handleBatal()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 70, marginRight: 10, cursor: 'pointer', marginTop: 48, }}>
                        <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                    </div>
                    <div onClick={() => handleSubmit()} style={{ backgroundColor: 'white', borderRadius: 70, textAlign: 'center', width: 205, height: 39, color: '#278863', border: "2px solid #278863", marginTop: 47, cursor: 'pointer' }}>
                        <Typography style={{ marginTop: 4 }}>Input Data Jadwal</Typography>
                    </div>
                </div>
            </div>
            {
                visibleError ? 
                <div className="App app-popup-show">
                    <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white', height: '30vh', display: 'grid' }}>
                        <div style={{margin: 'auto'}}>
                            <div style={{width: 90, height: 90, borderRadius: 70, backgroundColor: '#34b68b', border: '3px solid #b3fde4', placeContent: 'center'}}>
                                {/* <img src={circle} style={{width: 100, height: 100}}/> */}
                                <img src={ic_error} style={{width: 60, height: 60, marginTop: 10}}/>
                            </div>
                            <Typography style={{fontStyle: 'bold', letterSpacing: 1.5, fontFamily: 'poppins', fontSize: 18}}>Error</Typography>
                        </div>
                        <div>
                            <Typography>{errorMessage}</Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}>
                            <div onClick={() => setVisibleError(false)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Tutup</Typography>
                            </div>
                        </div>
                    </div>
                </div>
                : null
            }
        </div>
    )
}